import React from 'react'
import styled from 'styled-components'

import Grain from './Grain'

const PageHero = ({ children }) => {
  return (
    <Wrapper>
      <Grain />
      <Container>{children}</Container>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  position: relative;
  background: var(--color-background);
  padding: var(--size-16) 0;
  overflow: hidden;

  @media (min-width: 1024px) {
    padding: calc(2 * var(--size-16)) 0;
  }
`

const Container = styled.div`
  z-index: 2;
  position: relative;
  height: 100%;
  max-width: var(--max-width);
  padding: 0 var(--padding-x);
  margin: 0 auto;
  text-align: center;

  .headline {
    grid-column: 1 / -1;
    grid-row: 1 / 2;
    font-size: var(--font-size-9);

    @media (min-width: 768px) {
      font-size: var(--font-size-12);
    }

    .home & {
      font-size: var(--font-size-10);
      margin: 0 auto;

      @media (min-width: 768px) {
        font-size: var(--font-size-12);
      }
    }

    .year & {
      font-size: var(--font-size-12);

      @media (min-width: 768px) {
        font-size: 19.2rem;
      }
    }
  }

  .caption {
    grid-column: 1 / -1;
    grid-row: 2 / 2;
    width: 100%;
    max-width: unset;
  }
`

const Scrim = styled.div`
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  // This one only spans half the height...
  background: var(--color-gradient);
`

export default PageHero
